import React from 'react';
import { Outlet } from 'react-router-dom';

const PageGuard = () => {
  //TODO -> Add protection code
  return <Outlet />;
};

export default PageGuard;
